'use strict';

/**
 * @author Maxim Seredkin
 * @param {*} Notification
 * @return {*}
 */
export default ['ngToast',
    function(Notification) {
        return {
            info: info,
            warning: warning,
            danger: danger,
            success: success,
        };

        /**
         * INFO
         * @param {*} opts
         */
        function info({ title, message, ...opts }) {
            Notification.info({
                content: buildContent({ title, message }),
                ...opts,
            });
        }

        /**
         * WARNING
         * @param {*} opts
         */
        function warning({ title, message, ...opts }) {
            Notification.warning({
                content: buildContent({ title, message }),
                ...opts,
            });
        }

        /**
         * DANGER
         * @param {*} opts
         */
        function danger({ title, message, ...opts }) {
            Notification.danger({
                content: buildContent({ title, message }),
                ...opts,
            });
        }

        /**
         * SUCCESS
         * @param {*} opts
         */
        function success({ title, message, ...opts }) {
            Notification.success({
                content: buildContent({ title, message }),
                ...opts,
            });
        }

        /**
         * Собрать контент уведомления
         * @param {*} opts
         * @return {string}
         */
        function buildContent(opts) {
            let content = '';

            if (opts.title) {
                content += `<h4 class="text-left">${opts.title}</h4><hr />`;
            }

            if (opts.message) {
                content += `<p class="text-left">${opts.message}</p>`;
            }

            return content;
        }
    }];
